import { useSettings } from 'Settings'

import { TYPE } from 'configuration';

const statelessJSON = (json) => {
	if (json === undefined) {
		return json;
	}

	if (json['value'] !== undefined && json['setValue'] !== undefined) {
		return json['value']
	}

	let out = {}

	Object.entries(json).forEach(([key, value]) => {
		const sjson = statelessJSON(value)
		out[key] = sjson;
	})

	return out
}

const ExportJson = ({className, onClick}) => {
	const [settings] = useSettings()

	let json = statelessJSON(settings)
	json['type'] = TYPE;

	const dataStr = JSON.stringify(json, 0, 2);
	const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);

	const fileName = `config-${TYPE}.json`

	return (
		<a
			href={dataUri}
			download={fileName}
			className={className}
			onClick={onClick}
		>
			Export to JSON
		</a>
	)
}

export default ExportJson
export { statelessJSON }
